import { IonCol } from "@ionic/react";
import { useCallback, useEffect, useState } from "react";
import FilterList, { isFilterActive } from "../../../FilterList/FilterList";
import { FilterState } from "../../../FilterList/types";

import List from "../../../List/List";
import { useNamedRoutes } from "../../../NamedRoutes";
import { useIsMobile } from "../../../Responsive";
import type { ListFilter } from "../../SystemList";
import { Filter } from "../types/reportTypes";
import { DocumentationHistoryProps } from "./types";

type PersistentFilter = Filter<ListFilter> & FilterState;


const standardFilter: Filter<ListFilter> = {
    sortCriteria: "telephoneNumber",
    sortOrder: "ASC",
};

const ignoreKeys: (keyof PersistentFilter)[] = ["pageSize", "isFilterOpen", "page", "pageSize", "sortCriteria", "sortOrder"];

const SystemDocumentationHistory: React.FC<DocumentationHistoryProps> = ({
    system,
    filter,
    onIsOpen,
    onFilterActive
}) =>
{

    //TODO:Schauen wo das verwendet wird

    const { generate } = useNamedRoutes();
    const mobileView = useIsMobile();


    const [list, setList] = useState<any[] | null>([]);
    const [currentState, setState] = useState<PersistentFilter>({});

    const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
    const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
    const onResetFilter = useCallback(() => setState(() => standardFilter), [setState]);

    const isFilterChanged = isFilterActive<PersistentFilter>(currentState, standardFilter, ignoreKeys);

    useEffect(() =>
    {
        if (filter?.isFilterActive !== isFilterChanged) {
            onFilterActive && onFilterActive(isFilterChanged);
        }
    }, [isFilterChanged, filter, onFilterActive]);


    return <>
        <FilterList
            isOpen={filter?.isFilterOpen || false}
            isDetailsOpen={filter?.isDetailOpen || false}
            onIsOpen={onIsFilterOpen}
            onDetailOpen={onIsDetailFilterOpen}
            onReset={onResetFilter}
            noPrint
            details={<>
                <IonCol>
                    {/*  <TypeaheadString
                        id="systemId"
                        reset={clearFilterInputs}
                        onFilter={async (value: string) =>
                        {
                            setState({ ...currentState, systemId: (a: string, b: string): boolean => stringFilter(a, value) });
                            const list = await getList(list, 'systemId');
                            return list;
                        }}
                        disabled={!list.length}
                        text={"COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID"}
                    /> */}

                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
            </>}
        >

        </FilterList >

        <List
            rows={list}
            maxHeight={mobileView ? '86vh' : "58vh"}
            headers={[
                {
                    title: '[REACT_COMPARE.]', key: 'compare', both: true

                },
                {
                    title: 'COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID', key: 'systemId', both: true

                },
                {
                    title: 'COM_FACPMANAGEMENT_SHARES_ANLAGENNAME', key: 'systemname', breakpoint: 1200, up: true

                },
                {
                    title: 'COM_FACPMANAGEMENT_HISTORYSYSTEMS_XML_FILENAME', key: 'xmlFilename', breakpoint: 1200, up: true

                },
                {
                    title: 'COM_TEMPLATES_HOME_BUTTON', key: 'Documentation', breakpoint: 1200, up: true

                },
                {
                    title: 'COM_FACPMANAGEMENT_HISTORYSYSTEMS_CURRENT_STATE', key: 'currentStatus', breakpoint: 1200, up: true

                },
                {
                    title: 'MOD_LATEST_CREATED', key: 'created', breakpoint: 1200, up: true

                },
                {
                    title: 'COM_FACPMANAGEMENT_HISTORYSYSTEMS_FINISHED', key: 'finished', breakpoint: 1200, up: true

                },
                {
                    title: 'TD_USERNAME', key: 'user', breakpoint: 1200, up: true

                },
            ]}

        />
    </>;
};

export default SystemDocumentationHistory;
